import React, { Suspense } from 'react';
import { ApolloProvider } from 'react-apollo';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { ThemeProvider } from '@material-ui/core/styles';
import bootstrapApi from 'legacy-src/bootstrap/api';
import { store, client } from 'legacy-src/store';
import Routes from './routes';
import { apMuiTheme, LoadingSpinner } from 'legacy-ft-cb';
import 'legacy-src/styles/Main.scss';
import 'chameleon-styles/Globals.css';

const persistor = persistStore(store);
/**
 * Create our root react component.
 * @return {Root} JSX Component.
 */
const Root = () => {
  bootstrapApi();

  return (
    <ThemeProvider theme={apMuiTheme}>
      <ApolloProvider store={store} client={client}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes />
          </Suspense>
        </PersistGate>
      </ApolloProvider>
    </ThemeProvider>
  );
};

Root.displayName = 'ApolloRoot';

export default Root;
